import React from 'react';

// Replace this URL with your real photo upload to swap in your headshot.
export const PROFILE_PHOTO_URL = 'https://customer-assets.emergentagent.com/job_domain-resume/artifacts/t1vcwixc_ChatGPT%20Image%20May%208%2C%202026%2C%2003_52_55%20PM.png';

const Avatar = () => {
  if (PROFILE_PHOTO_URL) {
    return (
      <img
        src={PROFILE_PHOTO_URL}
        alt="Phillip Justus"
        className="w-[140px] h-[140px] object-cover border border-[#A0A0A0]"
        style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.18)' }}
      />
    );
  }
  return (
    <div
      className="w-[140px] h-[140px] flex items-center justify-center border border-[#1F4070] text-white"
      style={{
        background: 'linear-gradient(135deg, #2B579A 0%, #3C6BAC 100%)',
        boxShadow: '0 2px 8px rgba(0,0,0,0.18)',
        fontFamily: 'Segoe UI, sans-serif',
      }}
    >
      <span style={{ fontSize: 56, fontWeight: 300, letterSpacing: 2 }}>PJ</span>
    </div>
  );
};

const Bullet = ({ children }) => (
  <div className="flex items-start text-[12.5px] text-black leading-[1.5] mb-[3px]">
    <span className="text-[#2B579A] mr-[8px] mt-[2px]">{'\u25B6'}</span>
    <span>{children}</span>
  </div>
);

const WelcomeDialog = ({ open, onClose, onExplore }) => {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-[80] flex items-center justify-center"
      style={{ background: 'rgba(20, 30, 50, 0.45)', backdropFilter: 'blur(2px)' }}
    >
      <div
        className="bg-[#F5F5F5]/95 border border-[#808080] flex flex-col"
        style={{
          width: 'min(900px, 92vw)',
          maxHeight: '92vh',
          fontFamily: 'Tahoma, Segoe UI, sans-serif',
          boxShadow: '0 12px 40px rgba(0,0,0,0.35)',
        }}
      >
        {/* Title bar */}
        <div className="flex items-center justify-between h-[28px] bg-[#2B579A] text-white px-[10px] flex-shrink-0">
          <span className="text-[12.5px]">Welcome to philjustus.local</span>
          <button
            onClick={onClose}
            className="w-[32px] h-[28px] hover:bg-[#E81123] flex items-center justify-center"
            aria-label="Close"
          >
            <svg width="11" height="11" viewBox="0 0 11 11">
              <line x1="1" y1="1" x2="10" y2="10" stroke="#FFF" strokeWidth="1.3" />
              <line x1="10" y1="1" x2="1" y2="10" stroke="#FFF" strokeWidth="1.3" />
            </svg>
          </button>
        </div>

        {/* Body */}
        <div className="flex p-[18px] gap-[18px] overflow-auto">
          <div className="flex-shrink-0 flex flex-col items-center">
            <Avatar />
            <div className="mt-[10px] text-center">
              <div className="font-bold text-[14px] text-black">Phillip Justus</div>
              <div className="text-[11.5px] text-[#444]">Cyber Engineer / ISSM</div>
              <div className="text-[11px] text-[#666] mt-[2px]">12 years of IT &amp; Cybersecurity</div>
              <div className="text-[11px] text-[#666]">Langhorne, PA</div>
            </div>
          </div>

          <div className="flex-1 min-w-0 text-black">
            <div className="text-[14px] font-bold mb-[6px]">
              Hi &mdash; thanks for stopping by.
            </div>
            <div className="text-[12.5px] leading-[1.6] mb-[10px]">
              I&rsquo;m a cybersecurity engineer with 12 years of hands-on experience securing
              enterprise systems across identity, endpoint, infrastructure, and cloud
              environments. My background includes Identity and Access Management,
              vulnerability management, security engineering, endpoint protection, and
              security operations using platforms such as <strong>CrowdStrike</strong>,{' '}
              <strong>Splunk</strong>, <strong>FortiEDR</strong>, <strong>Entra ID</strong>,
              and <strong>Microsoft Defender</strong>.
            </div>
            <div className="text-[12.5px] leading-[1.6] mb-[12px]">
              I specialize in translating security frameworks into practical technical
              controls, improving visibility through SIEM and EDR tooling, and building
              automation that reduces operational overhead while strengthening security
              posture. I hold the <strong>CISSP</strong> and <strong>CCSP</strong> from ISC2.
            </div>

            <div className="bg-[#FFFFE0] border border-[#D0D0A0] p-[10px] mb-[12px]">
              <div className="font-bold text-[12.5px] mb-[4px]">A note on this site</div>
              <div className="text-[11.5px] leading-[1.5]">
                This portfolio is designed as a working clone of the Microsoft tool I use every day:
                <strong> Active Directory Users and Computers (ADUC)</strong>. My professional
                background is organized into Organizational Units (OUs) you can browse just like a real
                directory. Skills, certifications, projects, and roles are represented as user, group,
                and computer objects &mdash; double-click any item to open its &ldquo;Properties&rdquo; for details.
              </div>
            </div>

            <div className="font-bold text-[12.5px] mb-[6px]">What you&rsquo;ll find inside</div>
            <Bullet><strong>Users / Profile</strong> &mdash; the cybersecurity roles I&rsquo;m qualified for (ISSM/ISSO, GRC Analyst, IAM Analyst, Cyber Engineer, IT System Administrator)</Bullet>
            <Bullet><strong>Users / Certifications</strong> &mdash; CISSP, CCSP, Security+</Bullet>
            <Bullet><strong>Skills</strong> &mdash; technical competencies organized by domain (GRC, Defensive, Vulnerability Mgmt, Infrastructure, Cloud, Automation)</Bullet>
            <Bullet><strong>Areas of Expertise</strong> &mdash; the 12 focus areas I bring to a team</Bullet>
            <Bullet><strong>Education</strong> &mdash; academic and professional development</Bullet>

            <div className="mt-[10px] text-[12px] text-[#444]">
              <strong>Want to connect?</strong> Use the <em>Action &rarr; Contact / Inquiry</em>
              &nbsp;menu at the top, or revisit this welcome any time via <em>Action &rarr; Return to Welcome</em>.
            </div>
          </div>
        </div>

        {/* Footer buttons */}
        <div className="flex justify-end gap-[8px] bg-[#F0F0F0] px-[14px] py-[10px] border-t border-[#D0D0D0] flex-shrink-0">
          <button
            onClick={onExplore}
            className="min-w-[160px] h-[26px] text-[12px] border border-[#2B579A] bg-[#DCE9F9] hover:bg-[#C1D7F0] active:bg-[#B0CEEC] font-semibold"
            autoFocus
          >
            Explore the Directory
          </button>
        </div>
      </div>
    </div>
  );
};

export default WelcomeDialog;
